import { useFlags } from 'launchdarkly-react-client-sdk'
import { useIsLDReadyForUser } from 'mednet-cns/src/hooks/launchDarkly'

export default function useNewSearchExperienceFlag() {
  const isLdReady = useIsLDReadyForUser()

  const {
    questionSearchAlgorithm,
    enforceAlgoliaQuestionSearchInAutoComplete,
  } = useFlags()

  const enableNewSearchExperience =
    !enforceAlgoliaQuestionSearchInAutoComplete &&
    questionSearchAlgorithm === 'lux_and_llm'

  return {
    enableNewSearchExperience,
    isLdReady,
  }
}
